import styled, { css } from 'styled-components'

export const StyledWrapper = styled.section`
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const StyledSubTitle = styled.span`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;

  ${props =>
    props.isMarginLeft &&
    css`
      margin-left: 8px;
    `}
`

export const StyledButtonsWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  gap: 38px;
  margin-top: 28px;
`

export const StyledButtonContainer = styled.section`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 266px;
  height: 70px;
  box-shadow: 0px 2px 14px rgba(39, 55, 84, 0.08);
  border-radius: 8px;
  cursor: pointer;

  ${props =>
    props.isSelected &&
    css`
      border: 1px solid ${props.theme.colors.primary};
      & > span > span {
        visibility: visible;
      }
    `}
`

export const StyledRadioContainer = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  border: 1px solid #00112b;
  margin-left: 18px;
  margin-right: 20px;
`

export const StyledRadioCenter = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: ${props => props.theme.colors.primary};
  visibility: hidden;
`
